module.exports = __webpack_public_path__ + "img/simetrica.4caefaf8.png";